module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/zh-hant/1-cb079fdc1e15818515dedb5560eaf358.jpg";